import styled from 'styled-components';

import { CorUtil } from '@utils';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
  padding: 10px 16px;

  border-radius: 5px;
  background: ${(props) => CorUtil.rgba(props.theme.cores.info.padrao, 0.1)};
  border-left: 5px solid ${(props) => props.theme.cores.primaria.padrao};

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
    color: ${(props) => props.theme.cores.primaria.padrao};
  }

  strong {
    font-weight: 700;
  }
`;

export const MensagemGeral = styled.div`
  display: flex;
`;
